import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import he from 'he';

import siteData from '../services/siteData';
import api, { urlParamCharacter } from '../services/api';
import Detail from '../components/Detail';

export default class WorkPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      firstCreditRole: '',
      firstCreditPersonOrCompany: '',
      secondCreditRole: '',
      secondCreditPersonOrCompany: '',
      thirdCreditRole: '',
      thirdCreditPersonOrCompany: '',
      video: '',
      fullImageUrl: '',
      fullImageAlt: '',
      isLoading: true,
    };
  }

  componentDidMount() {
    const { match, history } = this.props;

    api.get(`/works${urlParamCharacter}slug=${match.params.slug}`)
      .then((response) => {
        const data = response.data[0];
        this.setState({
          title: data.title.rendered,
          firstCreditRole: data.acf.first_credit.role,
          firstCreditPersonOrCompany: data.acf.first_credit.person_or_company,
          secondCreditRole: data.acf.second_credit.role,
          secondCreditPersonOrCompany: data.acf.second_credit.person_or_company,
          thirdCreditRole: data.acf.third_credit.role,
          thirdCreditPersonOrCompany: data.acf.third_credit.person_or_company,
          video: data.acf.video,
          fullImageUrl: data.acf.full_image ? data.acf.full_image.url : '',
          fullImageAlt: data.acf.full_image ? data.acf.full_image.alt : '',
          isLoading: false,
        });
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(error);
        }

        history.push('/not-found');
      });
  }

  render() {
    const {
      title,
      firstCreditRole,
      firstCreditPersonOrCompany,
      secondCreditRole,
      secondCreditPersonOrCompany,
      thirdCreditRole,
      thirdCreditPersonOrCompany,
      video,
      fullImageUrl,
      fullImageAlt,
      isLoading,
    } = this.state;

    return (
      <>
        <Helmet>
          <title>{`${title ? `${he.decode(title)} - ` : ''}${siteData.title}`}</title>
        </Helmet>
        <h1 className="sr-only">{title}</h1>
        <Detail
          title={title}
          firstCreditRole={firstCreditRole}
          firstCreditPersonOrCompany={firstCreditPersonOrCompany}
          secondCreditRole={secondCreditRole}
          secondCreditPersonOrCompany={secondCreditPersonOrCompany}
          thirdCreditRole={thirdCreditRole}
          thirdCreditPersonOrCompany={thirdCreditPersonOrCompany}
          video={video}
          fullImageUrl={fullImageUrl}
          fullImageAlt={fullImageAlt}
          isLoading={isLoading}
        />
      </>
    );
  }
}

WorkPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      slug: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

WorkPage.defaultProps = {
  match: { params: { slug: '' } },
};
